import styled from '../utils/styled-components-wrapper.js'

export const LidoLogoStyles = styled.div`
  color: var(--lido-color-text);
  line-height: 0;
`
